const STAGES = {

    initial: {
        id: 'initial',
        title: 'Finding Dates and Tickets...',
        navigationDisabled: true,
        isRouteAvailable: false
    },

    events_list: {
        title: 'Choose an event',
        backText: 'Pick another event',
        breadcrumb: 'Events',
        path: 'events-list',
        id:'events-list',
        isRouteAvailable: true,
        previousStage: 'initial'
    },

    calendar: {
        title: 'When do you want to go?',
        backText: 'Events List',
        breadcrumb: 'Dates',
        path: 'calendar',
        id:'calendar',
        isRouteAvailable: true,
        previousStage: 'events_list'
    },

    tickets: {
        title: 'Choose your tickets',
        breadcrumb: 'Tickets',
        backText: 'More Dates',
        path: 'tickets',
        id:'tickets',
        isRouteAvailable: true,
        previousStage: 'calendar'
    },

    checkout: {
        title: 'Checkout',
        breadcrumb: 'Checkout',
        isRouteAvailable: true,
        previousStage: 'tickets'
    }
}

export default STAGES;